import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { useApolloClient } from '@apollo/client';
import ActionCableContext from './ActionCableContext';

const ApolloCableContext = createContext();

export const ApolloCableProvider = ({ children }) => {
  const { cache } = useApolloClient();
  const { cable } = useContext(ActionCableContext);

  const handleItemUpdate = ({ field, item }) => {
    cache.modify({
      id: cache.identify({
        __typename: field,
        ...item,
      }),
      fields: (fieldValue, { fieldName }) => {
        if (fieldName in item) {
          return item[fieldName];
        }
        return fieldValue;
      },
    });
  };

  const serverUpdateReceived = ({ body }) => {
    const { type, payload } = body;

    // eslint-disable-next-line default-case
    switch (type) {
      case 'apollo_cache_update_item':
        return handleItemUpdate(payload);
    }
  };

  const subscription = cable.subscriptions.create(
    { channel: 'Account::UserChannel' },
    {
      received: serverUpdateReceived,
    }
  );

  return (
    <ApolloCableContext.Provider value={{ subscription }}>
      {children}
    </ApolloCableContext.Provider>
  );
};

ApolloCableProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ApolloCableContext;
